import React, {FC} from 'react'
import TRow from './TRow'
import { useThemeMode } from '../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

type CustomTableProps = {
  data: Array<{
    columns: Array<{
      colIndex: number
      value: any
      type: 'text' | 'date' | 'integer' | 'decimal' | 'percent' | 'action'
      rowIndex: number
      dataKey: string
      rowGuid: string
      content?: any
    }>
    rowType: 'data' | 'header'
    rowIndex: number
    rowGuid: string
  }>
  onSort?: (crit: {Sort: string; Order: 'asc' | 'desc'}) => void
  activeSort?: {Sort: string; Order: 'asc' | 'desc'}
}


const CustomTable: FC<CustomTableProps> = ({data = [], activeSort, onSort}) => {
  const {mode} = useThemeMode()
  if (data.length <= 0) return null
  
  return (
    <table className='table'>
      <thead>
        <TRow
          key={'CT_ROW_HEADER' + data[0].rowGuid}
          columns={data[0].columns}
          rowIndex={data[0].rowIndex}
          rowType={data[0].rowType}
          activeSort={activeSort}
          onSort={onSort}
        />
      </thead>
      <tbody>
        {[...data].map((r, i) => {
          // console.log('r', r)
          if (i > 0) {
            return (
              <TRow
                key={'CT_ROW_' + r.rowGuid + '_' + mode}
                columns={r.columns}
                rowIndex={r.rowIndex}
                rowType={r.rowType}
              />
            )
          }
          return null
        })}
      </tbody>
    </table>
  )
}

export default CustomTable
